import { render } from "./BodySystem.vue?vue&type=template&id=12dbe99e&scoped=true"
import script from "./BodySystem.vue?vue&type=script&lang=js"
export * from "./BodySystem.vue?vue&type=script&lang=js"

import "./BodySystem.vue?vue&type=style&index=0&id=12dbe99e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dbe99e"]])

export default __exports__